import { Get } from '../utils/request';

export async function getEmailTemplateStatus(payload) {
  return Get('/emailtemplate/status', payload);
}

export async function changeEmailTemplateStatus(payload = {}) {
  return Get('/emailtemplate/update', payload);
}
